import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ResponseDto } from '../dtos/response.dto';
import { MaintenanceInfoDto } from '../dtos/maintenance-info.dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private http = inject(HttpClient);

  isMaintenanceInProgress: boolean = false;
  maintenanceEndTime: Date | null = null;

  fetchAndSetMaintenanceInfo(): Observable<boolean> {
    return this.http.get<ResponseDto<MaintenanceInfoDto>>(`${environment.apiHost}/api/v1/maintenance`)
      .pipe(
        tap(response => this.setMaintenanceInfo(response.data)),
        map(() => true),
        catchError(() => of(true)),
      );
  }

  setMaintenanceInfo(info: MaintenanceInfoDto) {
    this.isMaintenanceInProgress = info.isMaintenanceInProgress;
    this.maintenanceEndTime = info.maintenanceEndTime ? new Date(info.maintenanceEndTime) : null;
  }
}
